module.exports = __webpack_public_path__ + "img/icon-initial-hold.7753f75c.svg";